// extracted by mini-css-extract-plugin
module.exports = {"img_ontainer":"PreviewUploadImg_img_ontainer__3j0RB","img_wrapper":"PreviewUploadImg_img_wrapper__2L09y","close_icon":"PreviewUploadImg_close_icon__18U8N"};